<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex flex-row-reverse w-100">
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="main">
              <mat-icon
                class="mb-4"
                style="transform: scale(2.5)"
                svgIcon="success"
              ></mat-icon>
              <ng-container *ngIf="boobleModalData == 0">
                <p
                  class="message mb-4 mt-3"
                  [ngClass]="isMobile ? 'text-center' : ''"
                >
                  Ordem de recebimento gerada com sucesso!
                </p>
                <p class="description-inbound mb-4">
                  Avisaremos assim que o pagamento for identificado em nossa
                  conta no exterior para que possamos prosseguir com o
                  recebimento.
                </p>
              </ng-container>
              <ng-container *ngIf="boobleModalData == 1">
                <p
                  class="message mb-4 mt-3"
                  [ngClass]="isMobile ? 'text-center' : ''"
                >
                  Ordem de envio criada com sucesso!
                </p>
                <p class="description mb-4">
                  Nosso time irá analisar as informações e documentos enviados.
                </p>
              </ng-container>

              <button
                (click)="closeModal()"
                type="button"
                class="btn btn-block mt-4 w-25"
                [ngClass]="
                  companyId
                    ? 'btn-dark-primary-blue'
                    : 'btn-dark-primary-blue-pf'
                "
                type="button"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
